import { useEffect } from "react"
import { useLocation } from "react-router-dom"

// Scrolls the window back to the top on every route (pathname) change, so each
// page opens at the top instead of inheriting the previous page's scroll
// position. Rendered once inside <BrowserRouter>; renders nothing itself.
export default function ScrollToTop() {
    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])

    return null
}
